module.exports = __webpack_public_path__ + "img/queen.d589b9a4.jpg";